import { render, staticRenderFns } from "./GroupedList.vue?vue&type=template&id=295a7f64&lang=pug"
var script = {}
import style0 from "./GroupedList.vue?vue&type=style&index=0&id=295a7f64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports